import React from 'react';
import { Link } from "react-router-dom";

const NewSMS = () => {
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-1-1">
              <div className="dashboardIntro">
                <Link to="/vpbx-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>CREATE A SMS</h3>
                <p>Please provide the necessary details for the new SMS, including the subject and the text you would like to include in the message.</p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">SMS information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>SMS name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="SMS name"
                    aria-label="Input"
                  />
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>SMS subject</label>
                  <select className="uk-select" aria-label="Select">
                    <option value="" selected disabled hidden>
                        Select SMS subject...
                    </option>
                    <option>Option 01</option>
                    <option>Option 02</option>
                  </select>
                </div>
                
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>SMS Text</label>
                  <textarea className="uk-textarea" rows="5" placeholder="" aria-label="Textarea"></textarea>
                </div>
                

                <div className="uk-width-1-1@m uk-float-right">
                    <div className="formActionBtn uk-text-right">
                        <button className="whiteBtn">Cancel</button>
                        <button className="pinkBtn">Save</button>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default NewSMS